import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Typography, Box } from '@material-ui/core'
import { BootstrapInput } from '../../../../components/BootstrapInput'
import { InputBaseProps } from '@material-ui/core/InputBase/InputBase'
import { IntegrationDots, IntegrationDotsProps } from '../integrationDots'
import { useFormStyles } from '../../lib/hooks/useFormStyles'
import { DifferenceTooltip } from '../differenceTooltip'
import { HelpTooltip } from '../helpTooltip'

interface FormInputProps extends IntegrationDotsProps, Omit<InputBaseProps, 'name'> {
  name: string;

  label: string;

  marketplaceValue?: string;

  description?: string;
}

export const FormInput = ({
                            name,
                            label,
                            placeholder,
                            required,
                            disabled,
                            type = 'text',
                            types,
                            marketplaceValue,
                            description,
                            ...rest
                          }: FormInputProps) => {
  const classes = useFormStyles()
  const {control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={{required: required ? 'Это поле обязательно' : false}}
      render={({field, fieldState}) => (
        <Box>
          <Box display={'flex'} alignItems={'center'} className={classes.root}>
            <Typography variant="subtitle1" className={classes.label}>{label}</Typography>
            <Box className={classes.dotsContainer}>
              <IntegrationDots types={types}/>
              {description && <HelpTooltip title={description} />}
              {marketplaceValue && <DifferenceTooltip title={marketplaceValue}/>}
            </Box>
          </Box>
          <BootstrapInput
            {...field}
            value={field.value ?? ''}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            error={!!fieldState.error}
            fullWidth
          />
          {fieldState.error && (
            <Typography color="error" variant="caption">
              {fieldState.error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  )
}